const SMALL_COLUMN_MIN_WIDTH = 75;
const SMALL_COLUMN_DEFAULT_WIDTH = 100;

const LARGE_COLUMN_MIN_WIDTH = 200;

export const getColumns = () => [
    {
        dataField: 'PaymentCode',
        caption: 'Payment',
        allowEditing: false,
        width: SMALL_COLUMN_DEFAULT_WIDTH,
        minWidth: SMALL_COLUMN_MIN_WIDTH,
    },
    {
        dataField: 'PaymentDescription',
        caption: 'Description',
        minWidth: LARGE_COLUMN_MIN_WIDTH,
        isEditable: false,
        allowEditing: false,
    },
    {
        dataField: 'TotalAmount',
        caption: 'Amount',
        minWidth: SMALL_COLUMN_MIN_WIDTH,
        width: SMALL_COLUMN_DEFAULT_WIDTH,
        format: '#0.00',
        shouldFixToDecimalPlaces: true,
        allignment: 'right',
        allowEditing: false,
    }
];
